import { ReactNode, ReactElement } from 'react';
import { EventPanelMetadata } from '@mark43/cad-api';
import { AppNameProvider, AppName } from '@m43/core';
import { observer } from 'mobx-react-lite';
import { ShowErrorAlertProvider } from '../hooks/use-show-error-alert/use-show-error-alert';
import { AdditionalInfosProviderCore } from '../hooks/use-additional-infos/use-additional-infos';
import { useEventMetadataStore } from '../../event-panel/event-panel-form/event-metadata';
import { useAdditionalInfosProviderUtils } from '../../common/hooks/use-additional-infos-provider-utils';
import { useCrossClassEventsIds } from '../../common/hooks/use-cross-class-events-ids';

export const AdditionalInfosProvider = observer(
    ({ children }: { children: ReactNode }): ReactElement => {
        const metadata = useEventMetadataStore()?.state?.metadata ?? ({} as EventPanelMetadata);
        const { eventId } = metadata;
        const crossClassEventsIds = useCrossClassEventsIds();
        const {
            showErrorAlert,
            userId,
            notificationManager,
            initialFilters,
        } = useAdditionalInfosProviderUtils();

        if (eventId === undefined || metadata?.agencyEventNumber === undefined) {
            // eslint-disable-next-line react/jsx-no-useless-fragment
            return <>{children}</>;
        }

        return (
            <AppNameProvider appName={AppName.CAD_NEXT}>
                <ShowErrorAlertProvider showErrorAlert={showErrorAlert}>
                    <AdditionalInfosProviderCore
                        entityId={eventId}
                        entityNumber={metadata?.agencyEventNumber as string}
                        currentUserId={userId}
                        eventOptions={{ isScheduledEvent: metadata?.isScheduledEvent }}
                        notificationManager={notificationManager}
                        initialFilter={initialFilters}
                        crossClassEventsIds={crossClassEventsIds}
                    >
                        {children}
                    </AdditionalInfosProviderCore>
                </ShowErrorAlertProvider>
            </AppNameProvider>
        );
    }
);
